const localizers = {
  'loading.msg': () => `جارٍ التحميل...`,
  'SASServer.genericError.msg': () => `لا يمكن الوصول إلى الخادم.`,
  'SASReport.genericError.msg': () => `يتعذر تحميل التقرير المحدد.`,
  'SASReportImage.genericError.msg': () => `فشل تحميل صورة التقرير.`,
  'SASReportImage.imageNotSupported.msg': () => `الصور غير مدعومة لنوع محتوى التقرير هذا.`,
}
export default localizers;
